import(/* webpackMode: "eager" */ "/home/runner/work/thi-beacon-frontend/thi-beacon-frontend/src/app/(common-routes)/auth0/login/page.tsx");
